import DialogMotiveToRenewCredential from './DialogMotiveToRenewCredential';
export default DialogMotiveToRenewCredential;
export { default as DialogMotiveToRenewCredential } from './DialogMotiveToRenewCredential';